<template>
  <ul v-editable="blok" class="cs-summary">
    <StoryblokComponent
      v-for="childBlok in blok.blocks"
      :key="childBlok._uid"
      class="cs-summary__item"
      :blok="childBlok"
    />
  </ul>
</template>

<script lang="ts" setup>
import type { SbCsSummaryStoryblok } from '@/types'
interface Props {
  blok: SbCsSummaryStoryblok
}
defineProps<Props>()
</script>

<style lang="scss" scoped>
.cs-summary {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
